module.exports = __webpack_public_path__ + "password@2x.a375cea5e2b49ea0591be6544cb4c493.png";